import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import AifDetail from './components/AifDetail';
import { funds } from './data/funds';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        {funds.map(fund => (
          <Route
            key={fund.id}
            path={fund.path}
            element={<AifDetail fund={fund} />}
          />
        ))}
      </Routes>
    </Router>
  );
}

export default App;
